import React, {useCallback, useEffect, useRef} from 'react';
import Input from "../../../../../core/gd-form-elements/input/input";
import {SpaceSearch} from "../../search/space-search";

type Props = {
    spaceSearch     : SpaceSearch
}

export default function MenuTopHeader_SearchActive(props: Props) {

    const inputRef: any = useRef()
    const spaceSearch = props.spaceSearch

    const onFocus = ()=>{
        spaceSearch.isActive = true
        spaceSearch.reRender()
    }

    const onBlur = ()=>{
        if(spaceSearch.searchValue?.length === 0){
            spaceSearch.isActive = false
        }
        spaceSearch.reRender()
    }

    const onClear = ()=>{
        if(inputRef.current){
            spaceSearch.searchValue = ""
            inputRef.current.setValue("")
            inputRef.current.focus()
        }
        spaceSearch.reRender()
    }

    const onChangeSearchValue = (value: string)=>{
        spaceSearch.searchValue = value
        spaceSearch.reRender()
    }

    const delayedSearch = useCallback(_.debounce(onChangeSearchValue, 500), [])

    useEffect(() => {
        if(inputRef.current){
            inputRef.current.focus()
        }
    }, [spaceSearch.isActive]);

    return (

        <div className="top-header flex-row-between-center">
            <div className="search-input m-l-15 m-r-15">
                <Input ref={inputRef}
                       className="w-100-percent"
                       value={spaceSearch.searchValue}
                       onChange={delayedSearch}
                       onFocus={onFocus}
                       onBlur={onBlur}
                       placeholder="Search"/>
                {
                    spaceSearch.searchValue &&
                    spaceSearch.searchValue?.length > 0 &&
                    <div className="i5-delete fs-12"
                         onClick={onClear}/>
                }
            </div>
        </div>

    )
}
